import React from 'react';
import update from 'immutability-helper';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { FormBuilder } from 'shared-components/forms/form';
import { ProjectFormList } from './project-form-list';
import { fetchFavBoardByUser, fetchUserProjectDetails } from '../../../api/api-projects';
import { FormattedMessage, injectIntl } from 'react-intl';

class ProjectModalList extends React.Component {
  constructor (props) {
    super(props);

    this.projectListForm = this.projectListForm.bind(this);
    this.onChecked = this.onChecked.bind(this);
    this.saveSettings = this.saveSettings.bind(this);
    this.saveSettingsCallback = this.saveSettingsCallback.bind(this);
    this.analyticsPayload = this.analyticsPayload.bind(this);
    this.only1projectSaved = this.only1projectSaved.bind(this);

    this.state = {
      selectedProjects: {},
      projects: [],
      errorText: '',
      disableBtn: true
    };
    /* Example of selected projects:
      selectedProjects: {
        59727a50e21b8400051253f8: {
          attachment_id: "5953dfe9096ae009bc9c535c",
          action: 'delete'
        }
      };
      attachment_id = if has attachment_id listing currently attached to project
      action = User's action, checked (add) or unchecked (delete).
    */
  }

  componentWillMount () {
    const { listing, profile } = this.props;
    const accessToken = PSSessions.Cookies('PSAccess');
    const { _id } = listing;
    const query = `&f_values=${_id}`;
    const favBoardByUserPromise = new Promise((resolve, reject) => {
      fetchFavBoardByUser(profile.SSOid, query, accessToken, (res) => {
        if (res.error || 400 < res.statusCode) {
          reject(res.error);
        }
        resolve(res);
      });
    });

    const selectedProjects = () => {
      favBoardByUserPromise
        .then(res => {
          return _.keyBy(res.attachments, 'project_id');
        })
        .then(projectById => (
          _.reduce(projectById, (obj, val, key) => {
            const result = Object.assign({}, obj);
            result[key] = { attachment_id: val._id, action: '' };
            return result;
          }, {})
        ))
        .then(newProjectObj => {
          const { isFirstTime, analyticsOrigin, activity, useType, listingImgID } = this.analyticsPayload();
          const boardCount = this.state.projects.length;
          analyticsIntegrations.listBoardViewed(isFirstTime, listing, analyticsOrigin, activity, useType, listingImgID, boardCount);
          return this.setState({ selectedProjects: newProjectObj });
        })
        .catch(() => {
          this.setState({
            errorText: this.props.intl.formatMessage({ id: 'boards.project_modal_list.something_wrong_close', defaultMessage: 'Something went wrong. Please close the modal and try again later.' })
          });
        });
    };

    fetchUserProjectDetails(profile.SSOid, accessToken, (res) => {
      if (res.error || res.errors || 400 < res.statusCode) {
        // Something went wrong when fetching the project
        return this.setState({ errorText: this.props.intl.formatMessage({ id: 'boards.project_modal_list.something_wrong_refresh', defaultMessage: 'Something went wrong. Please refresh and try again later.' }) });
      }
      return this.setState({ projects: res.projects }, selectedProjects());
    });
  }

  onChecked (checked, callbackParams) {
    const { selectedProjects } = this.state;
    const { projectId } = callbackParams;

    if (checked) {
      // user wants to add a new listing to an existing board
      const newProjectsState = update(selectedProjects, {
        [projectId]: { $set: { action: 'create' } }
      });
      return this.setState({
        selectedProjects: newProjectsState,
        disableBtn: null
      });
    }

    if (selectedProjects[projectId].attachment_id) {
      // user removes a listing from an existing board that was previously saved
      const newProjectsState = update(selectedProjects, {
        [projectId]: { action: { $set: 'delete' } }
      });
      return this.setState({
        selectedProjects: newProjectsState,
        disableBtn: null
      });
    }

    // user wants to remove a listing from a board that has not been saved to yet
    const newProjectsState = update(selectedProjects, { $unset: [projectId] });
    return this.setState({
      selectedProjects: newProjectsState,
      disableBtn: null
    });
  }

  only1projectSaved () {
    const projects = this.state.projects.length ? this.state.projects : this.props.projects;
    const keyProjectsById = _.keyBy(projects, '_id');
    const projectsArray = projects ? Object.keys(keyProjectsById) : [];
    const listingSavedToTheseProjects = projectsArray.filter((projectId) => {
      const checked = this.state.selectedProjects.hasOwnProperty(projectId) && 'delete' !== this.state.selectedProjects[projectId].action;
      return checked;
    });
    return {
      count: listingSavedToTheseProjects.length,
      projectIDs: listingSavedToTheseProjects
    };
  }


  getListViewData (selectedProjects, createBoardCb) {
    const projectById = _.keyBy(selectedProjects, 'project_id');
    const newProjectObj = _.reduce(projectById, (obj, val, key) => {
      const result = Object.assign({}, obj);
      result[key] = { attachment_id: val._id, action: '' };
      return result;
    }, {});

    this.setState({ selectedProjects: newProjectObj });
    if (createBoardCb) { return createBoardCb(); }
    return null;
  }

  analyticsPayload () {
    const { listing, projects, analyticsOrigin } = this.props;
    const { uses, images } = listing;
    const [firstUse] = uses;
    const [firstImage] = images;
    const activity = PSSessions.Cookies('PSSK');

    const isFirstTime = 0 === projects.length || (1 === projects.length && 'UNCATEGORIZED_FAVS' === projects[0].type);

    // listings can have a different shape based on where the come from (search or listings API),
    // if use_type is available use it
    const useType = listing.use_type || firstUse;
    const listingImgID = firstImage.external_id;

    return {
      isFirstTime,
      listing,
      analyticsOrigin,
      activity,
      useType,
      listingImgID
    };
  }

  projectListForm () {
    const { selectedProjects } = this.state;
    const projects = this.state.projects.length ? this.state.projects : this.props.projects;
    // key hash by project id instead of external id.
    const keyProjectsById = _.keyBy(projects, '_id');
    const projectsArray = projects ? Object.keys(keyProjectsById) : [];
    return (
      projectsArray.length ? projectsArray.map((projectId) => {
        const checked = selectedProjects.hasOwnProperty(projectId) && 'delete' !== selectedProjects[projectId].action;
        const itemAction = checked ? 'remove' : 'add';

        return (
          <ProjectFormList
            key={`project-list-${projectId}`}
            {...keyProjectsById[projectId]}
            checked={checked}
            onChange={this.onChecked}
            itemAction={ itemAction }
            projectId={ projectId }
          />
        );
      }) :
        null
    );
  }

  beforeCTA () {
    const { selectedProjects } = this.state;
    const { setModalBody, projectsFromCreate } = this.props;
    const openCreateModal = (newProjects) => {
      setModalBody({
        modalType: 'create',
        origin: 'list',
        projectsFromCreate: newProjects
      });
    };
    const checkIfUserSelectedProjects = () => {
      const filteredProjects = _.filter(selectedProjects, (project) => {
        return '' !== project.action;
      });
      if (Object.keys(filteredProjects).length || projectsFromCreate) {
        return this.saveSettings(null, null, null, null, openCreateModal);
      }
      return openCreateModal();
    };
    return (
      <div className="col-sm-6 col-xs-7">
        <button className="btn link-span form new-project-btn" onClick={checkIfUserSelectedProjects}>+&nbsp;
          <FormattedMessage
            id="boards.project_modal_list.create_board"
            defaultMessage="Create New Board"
          />
        </button>
      </div>
    );
  }

  saveSettings (e, formCb, refs, formValues, createBoardCb) {
    const { selectedProjects } = this.state;
    const { listing, listSave, listingSavedToOnly1Board } = this.props;
    const only1projectSaved = this.only1projectSaved();

    const payload = {};
    const batch = _.reduce(selectedProjects, (result, val, key) => {
      if (val.attachment_id && 'delete' === val.action) {
        const deleteObj = {
          _id: val.attachment_id,
          action: val.action
        };
        result.push(deleteObj);
      } else if (!val.attachment_id && 'create' === val.action) {
        const createObj = {
          ns: 'FAV_BOARD',
          value: listing._id,
          project: key,
          action: 'create'
        };
        result.push(createObj);
      }
      return result;
    }, []);

    payload.batch = batch;

    const { analyticsOrigin, activity, useType, listingImgID } = this.analyticsPayload();
    listSave(payload, (CBresponse) => {
      // Save functionality happens at: Search & Board Details page
      // Search response comes directly from API
      // Board Details response comes from Redux, with response being normalized data, & a new field: rawResponse - directly from API
      const res = CBresponse.rawResponse ? CBresponse.rawResponse : CBresponse;

      // fire analytics
      if (_.some(res.responses, { message: 'Success' })) {
        const succBoardIds = this.reducedSelectedListingIds(res.responses, true);
        analyticsIntegrations.boardListingsSaved(listing, analyticsOrigin, activity, useType, listingImgID, false, succBoardIds);
      }

      if (_.some(res.responses, { message: 'attachment deleted' })) {
        const delBoardIds = this.reducedSelectedListingIds(res.responses, false);
        analyticsIntegrations.boardListingsSaved(listing, analyticsOrigin, activity, useType, listingImgID, false, delBoardIds, 'listing save removed (frontend)');
      }

      // fork callback when listing is only saved to 1 project
      const saveCB = (1 === only1projectSaved.count) ? listingSavedToOnly1Board : createBoardCb;
      // combine the following objects to create a new payload that umbrella's
      const combinedResponse = Object.assign({}, res, { listingSavedToOnly1Board: only1projectSaved });
      return this.saveSettingsCallback(combinedResponse, saveCB);
    });
  }

  reducedSelectedListingIds (listings, success) {
    const message = success ? 'Success' : 'attachment deleted';
    return _.reduce(listings, (acc, listing) => {
      if (message === listing.message) {
        acc.push(listing._id || _.get(listing, ['attachment', 'project_id'], null));
      }
      return acc;
    }, []);
  }

  saveSettingsCallback (res, saveCB) {
    const { listSaveCallback, listing } = this.props;
    if (res.error || res.errors || 400 < res.statusCode) {
      // Something went wrong when creating the project
      return this.setState({ errorText: this.props.intl.formatMessage({ id: 'boards.project_modal_list.something_wrong_settings', defaultMessage: 'Something went wrong. Please try again later.' }) });
    }
    this.setState({ errorText: '' });
    return listSaveCallback(res, saveCB, listing);
  }

  additionalBody () {
    return (
      <div className="project-list-addition">
        <hr className="flat" />
      </div>
    );
  }

  render () {
    const { disableBtn } = this.state;
    return (
      <div className="project-list-body">
        <h3 className="text-center project-heading">
          <FormattedMessage
            id="boards.project_modal_list.save_space"
            defaultMessage="Save your space to a board and stay organized"
          />
        </h3>
        <hr className="flat hidden-xs" />
        <div className="project-list-container">
          <FormBuilder
            ref="boardListForm"
            formname="board list form"
            formStyle="modal-plus"
            formInputs={[{ custom: this.projectListForm }]}
            submitAction={this.saveSettings}
            submitCallback={this.saveSettingsCallback}
            additionalBody={this.additionalBody()}
            buttonText={this.props.intl.formatMessage({ id: 'boards.project_modal_list.save_button', defaultMessage: 'Save' })}
            btnColSize="col-sm-4 col-sm-offset-2 col-xs-4 col-xs-offset-1"
            buttonClass="btn btn-lg btn-primary form"
            errorText={this.state.errorText}
            beforeCTA={this.beforeCTA()}
            isButtonDisabled={disableBtn}
            isDisableSpinning={disableBtn}
            useBootstrapGrid={false}
          />
        </div>
      </div>
    );
  }
}

ProjectModalList.propTypes = {
  listSave: PropTypes.func.isRequired,
  accessToken: PropTypes.string.isRequired,
  listing: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  projects: PropTypes.array.isRequired,
  projectsFromCreate: PropTypes.array,
  setModalBody: PropTypes.func.isRequired,
  listingSavedToOnly1Board: PropTypes.func,
  analyticsOrigin: PropTypes.string,
  listSaveCallback: PropTypes.func
};

exports.ProjectModalList = injectIntl(ProjectModalList);
